import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  // flexSpace: {
  //   width: '100%',
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  // },
  filterHeader: {
    padding: '24px 32px'
    // borderBottom: `1px solid ${palette.shades[300]}`,
  },
  filterContent: {
    padding: '24px 32px',
    background: palette.gradients.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  // addressWrapper: {
  //   padding: '24px 32px',
  //   borderBottom: `1px solid ${palette.shades[300]}`,
  // },
  accordion: {
    boxShadow: 'none',
    background: palette.gradients.white,
    '& .MuiAccordionSummary-root': {
      padding: '24px 32px',
      boxShadow: palette.shadows.light
    },
    '&.Mui-expanded': {
      margin: '0'
    }
  },
  accordionDetails: {
    padding: '24px 32px',
    backgroundColor: palette.shades[200]
  },
  select: {
    width: '320px',
    marginLeft: '10px'
  },
  addressBlock: {
    '& + &': {
      marginTop: '10px'
    }
  },
  actionButton: {
    marginLeft: '20px'
  }
}));
export default useStyles;